import React from 'react';
import LayoutIndex from './components/pages';


function App() {
  return (
    <div className="App">
      <LayoutIndex />
    </div>
  );
}

export default App;
